import React from 'react';
import { Chip, Icon } from '@material-ui/core';

import { VehicleModel } from '../../../../../Models/VehicleModel';

interface IVehicleChipProps {
    vehicle: VehicleModel,
    selected: boolean,
    onSelectVehicle?: (vehicle: VehicleModel) => void,
    onDeselectVehicle?: (vehicle: VehicleModel) => void
}

function CutoutVehicleChip({ vehicle, selected, onSelectVehicle, onDeselectVehicle }: IVehicleChipProps) {

    return (
        <Chip
            color="primary"
            variant={selected ? 'default' : 'outlined'}
            label={vehicle.nomenclature}
            onClick={() => {
                if (selected && onDeselectVehicle) {
                    onDeselectVehicle(vehicle);
                }
                else if (!selected && onSelectVehicle) {
                    onSelectVehicle(vehicle);
                }
            }}
            onDelete={() => {
                if (selected && onDeselectVehicle) {
                    onDeselectVehicle(vehicle);
                }
            }}
            deleteIcon={selected ? <Icon>close</Icon> : <></>}
            style={{ margin: '4px' }}
        />
    );
}

export default React.memo(
    CutoutVehicleChip,
    (p, n) => (p.selected === n.selected)
);